import { render, staticRenderFns } from "./NewSettlement.vue?vue&type=template&id=3d597a00&scoped=true"
import script from "./NewSettlement.vue?vue&type=script&lang=js"
export * from "./NewSettlement.vue?vue&type=script&lang=js"
import style1 from "./NewSettlement.vue?vue&type=style&index=1&id=3d597a00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d597a00",
  null
  
)

export default component.exports